/**
 * @generated SignedSource<<1f58f604659fa91fe7742da41efc99bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegenerateForLanguageModalMutation$variables = {
  languageCode: string;
  meetingRecordingId: string;
};
export type RegenerateForLanguageModalMutation$data = {
  readonly regenerateMeetingTranscriptAndSummaryForLanguage: {
    readonly meetingRecording: {
      readonly " $fragmentSpreads": FragmentRefs<"RegenerateForLanguageModalFragment_meetingRecording">;
    };
  } | null;
};
export type RegenerateForLanguageModalMutation = {
  response: RegenerateForLanguageModalMutation$data;
  variables: RegenerateForLanguageModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "languageCode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "languageCode",
    "variableName": "languageCode"
  },
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegenerateForLanguageModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "RegenerateMeetingTranscriptAndSummaryForLanguage",
        "kind": "LinkedField",
        "name": "regenerateMeetingTranscriptAndSummaryForLanguage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RegenerateForLanguageModalFragment_meetingRecording"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RegenerateForLanguageModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "RegenerateMeetingTranscriptAndSummaryForLanguage",
        "kind": "LinkedField",
        "name": "regenerateMeetingTranscriptAndSummaryForLanguage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detectedLanguage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languageConfidenceScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canRegenerateSummary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "regenerationForLanguageIsInProgress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b131b53fe3db28cb1fa7e9488ce48343",
    "id": null,
    "metadata": {},
    "name": "RegenerateForLanguageModalMutation",
    "operationKind": "mutation",
    "text": "mutation RegenerateForLanguageModalMutation(\n  $meetingRecordingId: ID!\n  $languageCode: String!\n) {\n  regenerateMeetingTranscriptAndSummaryForLanguage(meetingRecordingId: $meetingRecordingId, languageCode: $languageCode) {\n    meetingRecording {\n      ...RegenerateForLanguageModalFragment_meetingRecording\n      id\n    }\n  }\n}\n\nfragment RegenerateForLanguageModalFragment_meetingRecording on MeetingRecording {\n  id\n  detectedLanguage\n  languageConfidenceScore\n  canRegenerateSummary\n  regenerationForLanguageIsInProgress\n}\n"
  }
};
})();

(node as any).hash = "deb5d83b7f1f21acf4c89c253a93dd7e";

export default node;
